export default __webpack_public_path__ + "images/5ce4586cd719fecd1ce4e61a6214278e.png";